export const headersExcel = [
    {
        text: 'ID',
        value: 'id',
        sortable: true,
    },
    {
        text: 'DATA CRIACAO',
        value: 'createdDate',
        sortable: true,
    },
    {
        text: 'DESCRICAO',
        value: 'description',
        sortable: true,
    },
    {
        text: 'CLIENTE',
        value: 'clientName',
        sortable: true,
    },
    {
        text: 'ID CLIENTE',
        value: 'clientID',
        sortable: true,
    },
    {
        text: 'PLACA',
        value: 'plate',
        sortable: true,
    },
    {
        text: 'ID VEICULO',
        value: 'vehicleID',
        sortable: true,
    },
    {
        text: 'ISOLADO',
        value: 'isolated',
        sortable: true,
    },
    {
        text: 'CRIADO POR',
        value: 'account',
        sortable: true,
    },
    {
        text: 'ID CONTA',
        value: 'accountID',
        sortable: true,
    },
    {
        text: 'EQUIPAMENTOS',
        value: 'equipments',
        sortable: false,
        transformer: (equipments) => {
            if (!equipments || equipments.length === 0) {
                return '';
            }
            return equipments
                .map(eq => `${eq.name} (${eq.model} - ${eq.type})`)
                .join(', ');
        }
    },
    {
        text: 'POSSUI CUSTO',
        value: 'hadCost',
        sortable: true,
    },
    {
        text: 'CUSTO (R$)',
        value: 'cost',
        sortable: true,
        transformer: (cost) => {
            if (cost === null || cost === undefined) {
                return '';
            }
            return (cost / 100).toFixed(2);
        }
    },
    {
        text: 'RESPONSAVEL PELO CUSTO',
        value: 'costResponsibility',
        sortable: true,
    },
];
